import { create } from 'zustand';

import { GProduct } from '@/types';

interface ProductDetailState {
  product?: GProduct;
  setProduct: (_product?: GProduct) => void;
}

export const useProductDetailStore = create<ProductDetailState>()(set => ({
  product: undefined,
  setProduct: (product?: GProduct) => set({ product }),
}));
